import React from "react";
import {
  Paper,
  Box,
  Typography,
  Button,
  useTheme,
  Divider,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const DashboardMianCard = ({
  title,
  showButton = false,
  buttonLabel = "Action",
  onButtonClick,
  minHeight = 120,
  p = 3,
  sx = {},
  children,
  showToggleView = false,
  ...other
}) => {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  // Glassy background, border, shadow
  const glassBg = isLight ? "rgba(255,255,255,0.85)" : "rgba(34,45,59,0.82)";
  const borderColor = isLight ? "rgba(2,89,165,0.12)" : "rgba(0,188,212,0.18)";
  const boxShadow = isLight
    ? "0 8px 32px 0 rgba(2,89,165,0.10), 0 3px 16px 0 rgba(0,0,0,0.06)"
    : "0 8px 32px 0 rgba(0,188,212,0.12), 0 3px 16px 0 rgba(0,0,0,0.23)";

  return (
    <Paper
      elevation={0}
      sx={{
        p,
        borderRadius: 4,
        minHeight,
        background: glassBg,
        boxShadow: boxShadow,
        border: `1.2px solid ${borderColor}`,
        backdropFilter: "blur(7px)",
        transition: "box-shadow 0.22s, transform 0.17s",

        ...sx,
      }}
      {...other}
    >
      {(title || showButton) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          {title && (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.15rem", md: "1.3rem" },
                letterSpacing: 0.1,
                color: theme.palette.text.primary,
              }}
            >
              {title}
            </Typography>
          )}
          {showButton && (
            <Button
              endIcon={<ArrowForwardIosIcon sx={{ fontSize: 16 }} />}
              variant="outlined"
              size="small"
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.95rem", md: "1rem" },
                px: 2,
                background: isLight
                  ? "linear-gradient(90deg, #e3f2fd 0%, #f4f8fb 100%)"
                  : "linear-gradient(90deg, #233044 0%, #181f2a 100%)",
                borderColor: isLight
                  ? "rgba(2,89,165,0.18)"
                  : "rgba(0,188,212,0.28)",
                color: theme.palette.primary.main,
                boxShadow: isLight
                  ? "0 1px 4px 0 rgba(2,89,165,0.06)"
                  : "0 1.5px 4px 0 rgba(0,188,212,0.10)",
                "&:hover": {
                  background: isLight
                    ? "rgba(2,89,165,0.08)"
                    : "rgba(0,188,212,0.10)",
                  borderColor: theme.palette.primary.main,
                },
              }}
              onClick={onButtonClick}
            >
              {buttonLabel}
            </Button>
          )}

          {showToggleView && <></>}
        </Box>
      )}
      <Divider sx={{ mb: 2, borderColor: isLight ? "#e3eaf3" : "#2c3a4e" }} />

      {children}
    </Paper>
  );
};

export default DashboardMianCard;
